import { fetcher } from "helpers/fetcher";

import {
  TDeleteStaffMaternityChldrenLeaveReq,
  TDeleteStaffMaternityChldrenLeaveRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const deleteStaffMaternityChldrenLeave = async (
  payload: TDeleteStaffMaternityChldrenLeaveReq
) => {
  return await fetcher<
    TDeleteStaffMaternityChldrenLeaveRes,
    TDeleteStaffMaternityChldrenLeaveReq["data"]
  >(ENDPOINT.USER.DELETE_STAFF_MATERNITY_CHILDREN_LEAVE, {
    data: payload.data,
    headers: {
      [API_HEADER.USER_ID]: payload.idUser,
      [API_HEADER.VERSION]:
        ENDPOINT.USER.DELETE_STAFF_MATERNITY_CHILDREN_LEAVE.version,
    },
  });
};

export const mutationDeleteStaffMaternityChldrenLeave = async (
  payload: TDeleteStaffMaternityChldrenLeaveReq
) => {
  return (await deleteStaffMaternityChldrenLeave(payload)).data.message;
};

mutationDeleteStaffMaternityChldrenLeave._key = (
  payload: TDeleteStaffMaternityChldrenLeaveReq
) => [ENDPOINT.USER.DELETE_STAFF_MATERNITY_CHILDREN_LEAVE.url, payload];
